<template>
  <div class="industry-news-module">
    <div class="row news-type-tab">
      <el-button
        class="news-type-tab-btn"
        :class="{'news-type-tab-active': item === selectedOptionTab}"
        v-for="(item, index) in dateRangeTabs"
        :key="index"
        @click="onTabClick(item)"
      >{{item}}</el-button>
    </div>
    <industry-news-list v-if="selectedOptionTab === '中信一级行业舆情'"></industry-news-list>
    <industry-theme-news-list v-if="selectedOptionTab === '市场主题舆情'"></industry-theme-news-list>
  </div>
</template>

<script>
import IndustryNewsList from '@/components/news-monitor/IndustryNewsList';
import IndustryThemeNewsList from '@/components/whole-network/IndustryThemeNewsList';

export default {
  data() {
    return {
      dateRangeTabs: ['中信一级行业舆情', '市场主题舆情'],
      selectedOptionTab: '中信一级行业舆情'
    };
  }, 
  methods: {
    onTabClick(res) {
      this.selectedOptionTab = res;
    }
  },
  components: {
    IndustryNewsList,
    IndustryThemeNewsList
  }
};
</script>

<style lang="scss" scoped>
.industry-news-module {
  padding-top: 16px;
  background-color: #ffffff;
}
.news-type-tab {
  padding-left: 24px;
  height: 26px;
  .news-type-tab-btn {
    height: 26px;
    // width: 52px;
    margin-left: 0;
    margin-right: 6px;
    padding: 0 8px;
    border-radius: 2px;
    border: none;
    font-size: 14px;
    color: #747990;
    background-color: #f7f8fc;
    font-weight: 400;
    &:hover {
      color: #747990;
      background-color: #eaebef;
    }
    &:focus {
      color: #747990;
      background-color: #eaebef;
    }
    &:active {
      color: #747990;
      background-color: #eaebef;
    }
  }
  .news-type-tab-active {
    color: #ffffff;
    background-color: #45a8cc;
    font-weight: 400;
    &:hover {
      color: #ffffff;
      background-color: #3e97b8;
    }
    &:focus {
      color: #ffffff;
      background-color: #3e97b8;
    }
    &:active {
      color: #ffffff;
      background-color: #3e97b8;
    }
  }
}
</style>
